import ConsultaTaller from "views/examples/ConsultaTaller";
import Login from "views/examples/Login.js";
import Ordenes from "views/examples/Ordenes";
import OrdenesHistorico from "views/examples/OrdenesHistorico";
import Profile from "views/examples/Profile";
import ConsultaHistoricoSicom from "views/examples/RegistrosSicom";
import Reportes from "views/examples/Reportes";
import Consultas from "views/examples/consultas";
import ConsultaCargaMasiva from "views/examples/CargaMasiva";

var routesInspector = [
  {
    path: "/Ordenes",
    name: "Ordenes",
    icon: "ni ni-shop text-blue",
    component: <Ordenes />,
    layout: "/admin",
  },
  {
    path: "/OrdenesHisorico",
    name: "Órdenes Historico",
    icon: "ni ni-single-02 text-blue",
    component: <OrdenesHistorico />,
    layout: "/admin",
  },
  {
    path: "/user-profile",
    name: "Perfil",
    icon: "ni ni-single-02 text-blue",
    component: <Profile />,
    layout: "/admin",
  },
  {
    name: " Consultas",
    icon: "ni ni-chat-round text-blue",
    routes: [
      {
        path: "/consultas",
        name: "Consultas Vehiculos",
        icon: "fa fa-question-circle text-blue",

        component: <Consultas />,
        layout: "/admin",
      },

      {
        path: "/ConsultaHistoricoSicom",
        name: "Consulta Historico Sicom",
        icon: "fa fa-desktop text-blue",
        component: <ConsultaHistoricoSicom />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/login",
    name: "",
    component: <Login />,
    layout: "/auth",
  },
];
export default routesInspector;
